import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import { isLoggedInWithRole } from 'src/components/account/login';
import { UserRole } from 'src/common';
import { getOwnAccount } from 'src/selectors/accounts';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import { blue700, yellow600 } from 'material-ui/styles/colors';
import EuroIcon from 'material-ui/svg-icons/action/euro-symbol';
import HomeIcon from 'material-ui/svg-icons/action/home';
import CategoryIcon from 'material-ui/svg-icons/av/library-books';
import TextFormatIcon from 'material-ui/svg-icons/content/text-format';
import BusIcon from 'material-ui/svg-icons/maps/directions-bus';
import GeofenceIcon from 'material-ui/svg-icons/maps/layers';
import CustomerIcon from 'material-ui/svg-icons/social/person';
import DriverIcon from 'material-ui/svg-icons/action/assignment-ind';
import SunIcon from 'material-ui/svg-icons/image/wb-sunny';
import DateRangeIcon from 'material-ui/svg-icons/action/date-range';
import CountryIcon from 'material-ui/svg-icons/image/panorama';
import CustomerGroupIcon from 'material-ui/svg-icons/social/group';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import IntegrationIcon from 'material-ui/svg-icons/editor/insert-chart';
import InvoiceIcon from 'material-ui/svg-icons/action/receipt';
import StarRatingIcon from 'material-ui/svg-icons/action/stars';
import StoreIcon from 'material-ui/svg-icons/action/store';
import ForumIcon from 'material-ui/svg-icons/communication/forum';
import MapIcon from 'material-ui/svg-icons/maps/map';
import CalendarMonthIcon from 'material-ui/svg-icons/action/event';
import AddCircleIcon from 'material-ui/svg-icons/content/add-circle';
import LoyaltyIcon from 'material-ui/svg-icons/action/loyalty';

let SelectableList = makeSelectable(List);

export const reviewAdministrationFilterMappings = t => ({
    MY_REVIEWS: {
        filter: 'MY_REVIEWS',
        title: t('colors.own_tasks'),
    },
    MY_UNANSWERED_REVIEWS: {
        filter: 'MY_UNANSWERED_REVIEWS',
        title: t('colors.own_tasks'),
    },
});

const items = [
    '/administration/company',
    '/administration/categories',
    '/administration/seasons',
    '/administration/countries',
    '/administration/calculation',
    '/administration/buses',
    '/administration/drivers',
    '/administration/customers',
    '/administration/customer-group-settings',
    '/administration/customer-groups',
    '/administration/discount-groups',
    '/administration/templates',
    '/administration/settings',
    '/administration/store',
    '/administration/integration',
    '/administration/invoices',
    '/administration/referrals',
    '/administration/task-ratings',
    '/administration/calendar-season-calculation',
    '/administration/calendar-season',
    '/administration/calendar-season-calculation-calendar',
    '/administration/geofence',
    '/administration/zone-calculation',
];

class Administration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            selectedIndex: Math.max(items.indexOf(window.location.pathname), 0),
        };
    }

    componentWillMount() {
        this.redirect(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.redirect(nextProps);
    }

    redirect(props) {
        const { ownAccount, push, busCompany } = props;

        const currentPath = props.location.pathname;
        const isDispatcher = isLoggedInWithRole(ownAccount, [UserRole.DISPATCHER]);

        if (isDispatcher) {
            // redirect dispatcher to /administration/customers
            if (currentPath !== '/administration/customers' && currentPath !== '/administration/integration')
                push('/administration/customers');
        }
        // redirect non-dispatcher from /administration home to /administration/company
        else if (currentPath === '/administration') push('/administration/company');

        if (
            currentPath === '/administration/calendar-season-calculation-calendar' &&
            busCompany.entity &&
            !busCompany.entity.calendarSeasonCalculationEnabled
        )
            push('/administration/company');
        if (
            currentPath === '/administration/calendar-season-calculation' &&
            busCompany.entity &&
            !busCompany.entity.calendarSeasonCalculationEnabled
        )
            push('/administration/company');
    }

    render() {
        const { ownAccount, push, children, busCompany, t } = this.props;
        const filterMapping = reviewAdministrationFilterMappings(t);
        const isDispatcher = isLoggedInWithRole(ownAccount, [UserRole.DISPATCHER]);

        if (isDispatcher)
            return (
                <div className="row">
                    <div id="administration" className="col-md-2 sidebar-listview">
                        <SelectableList
                            selectedItemStyle={{
                                backgroundColor: '#0a71ba1a',
                            }}
                            value={this.state.selectedIndex}
                            onChange={(event, index) => this.setState({ selectedIndex: index })}>
                            <ListItem
                                className="styled-list-item"
                                key={0}
                                value={0}
                                primaryText={t('customer_details.customer')}
                                leftIcon={<CustomerIcon color={blue700} />}
                                onClick={() => push('/administration/customers')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={1}
                                value={1}
                                primaryText={t('administration.statistics_tool')}
                                leftIcon={<IntegrationIcon color={blue700} />}
                                onClick={() => push('/administration/integration')}
                            />
                        </SelectableList>
                    </div>
                    <div className="col-md-10">{children}</div>
                </div>
            );
        else
            return (
                <div className="row">
                    <div id="administration" className="col-md-2 sidebar-listview">
                        <SelectableList
                            selectedItemStyle={{
                                backgroundColor: '#0a71ba1a',
                            }}
                            value={this.state.selectedIndex}
                            onChange={(event, index) => this.setState({ selectedIndex: index })}>
                            <ListItem
                                className="styled-list-item"
                                key={0}
                                value={0}
                                primaryText={t('companies.company_data')}
                                leftIcon={<HomeIcon color={blue700} />}
                                onClick={() => push('/administration/company')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={1}
                                value={1}
                                primaryText={t('common_phrases.categories')}
                                leftIcon={<CategoryIcon color={blue700} />}
                                onClick={() => push('/administration/categories')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={4}
                                value={4}
                                primaryText={t('administration.calculation')}
                                leftIcon={<EuroIcon color={blue700} />}
                                onClick={() => push('/administration/calculation')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={2}
                                value={2}
                                primaryText={t('administration.season_calculation')}
                                leftIcon={<SunIcon color={blue700} />}
                                onClick={() => push('/administration/seasons')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={3}
                                value={3}
                                primaryText={t('administration.country_geofence_calculation')}
                                leftIcon={<CountryIcon color={blue700} />}
                                onClick={() => push('/administration/countries')}
                                nestedItems={[
                                    <ListItem
                                        className="styled-list-item"
                                        key={21}
                                        value={21}
                                        primaryText={t('geofence.title')}
                                        leftIcon={<GeofenceIcon color={blue700} />}
                                        onClick={() => push('/administration/geofence')}
                                    />,
                                    busCompany.entity && busCompany.entity.geoZoneFlatRateCalculationEnabled ? (
                                        <ListItem
                                            className="styled-list-item"
                                            key={22}
                                            value={22}
                                            primaryText={t('zone_calculation.title')}
                                            leftIcon={<MapIcon color={blue700} />}
                                            onClick={() => push('/administration/zone-calculation')}
                                        />
                                    ) : null,
                                ].filter(Boolean)}
                            />
                            {busCompany.entity && busCompany.entity.calendarSeasonCalculationEnabled && (
                                <ListItem
                                    className="styled-list-item"
                                    key={18}
                                    value={18}
                                    primaryText={t(`calendar_season_calculation.title`)}
                                    leftIcon={<DateRangeIcon color={blue700} />}
                                    onClick={() => push('/administration/calendar-season-calculation')}
                                    nestedItems={[
                                        <ListItem
                                            className="styled-list-item"
                                            key={19}
                                            value={19}
                                            primaryText={t('calendar_season_calculation.create_season')}
                                            leftIcon={<AddCircleIcon color={blue700} />}
                                            onClick={() => push('/administration/calendar-season')}
                                        />,
                                        <ListItem
                                            className="styled-list-item"
                                            key={20}
                                            value={20}
                                            primaryText={t('calendar_season_calculation.calendar.title')}
                                            leftIcon={<CalendarMonthIcon color={blue700} />}
                                            onClick={() => push('/administration/calendar-season-calculation-calendar')}
                                        />,
                                    ]}
                                />
                            )}
                            <ListItem
                                className="styled-list-item"
                                key={5}
                                value={5}
                                primaryText={t('companies.buses')}
                                leftIcon={<BusIcon color={blue700} />}
                                onClick={() => push('/administration/buses')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={6}
                                value={6}
                                primaryText={t('administration.driver')}
                                leftIcon={<DriverIcon color={blue700} />}
                                onClick={() => push('/administration/drivers')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={7}
                                value={7}
                                primaryText={t('customer_details.customer')}
                                leftIcon={<CustomerIcon color={blue700} />}
                                onClick={() => push('/administration/customers')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={8}
                                value={8}
                                primaryText={t('customer_group.group_settings')}
                                leftIcon={<CustomerGroupIcon color={blue700} />}
                                onClick={() => push('/administration/customer-group-settings')}
                                nestedItems={[
                                    <ListItem
                                        className="styled-list-item"
                                        key={9}
                                        value={9}
                                        primaryText={t('customer_group.group_discounts')}
                                        leftIcon={<LoyaltyIcon color={blue700} />}
                                        onClick={() => push('/administration/customer-groups')}
                                    />,
                                ]}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={10}
                                value={10}
                                primaryText={t('administration.discount_groups')}
                                leftIcon={<CustomerGroupIcon color={blue700} />}
                                onClick={() => push('/administration/discount-groups')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={16}
                                value={16}
                                primaryText={t('administration.task_ratings.ratings')}
                                leftIcon={<StarRatingIcon color={blue700} />}
                                onClick={() => push('/administration/task-ratings')}
                                nestedItems={[
                                    <ListItem
                                        className="styled-list-item"
                                        key={17}
                                        value={filterMapping.MY_UNANSWERED_REVIEWS.filter}
                                        primaryText={t('administration.task_ratings.unanswered')}
                                        leftIcon={<ForumIcon color={blue700} />}
                                        onClick={() => this.changeFilter(filterMapping.MY_UNANSWERED_REVIEWS)}
                                    />,
                                ]}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={11}
                                value={11}
                                primaryText={t('administration.template')}
                                leftIcon={<TextFormatIcon color={blue700} />}
                                onClick={() => push('/administration/templates')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={12}
                                value={12}
                                primaryText={t('global_settings.settings')}
                                leftIcon={<SettingsIcon color={blue700} />}
                                onClick={() => push('/administration/settings')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={13}
                                value={13}
                                primaryText={
                                    <span>
                                        {t('modules_store.store')}
                                        <sup
                                            style={{
                                                marginLeft: 2,
                                                color: yellow600,
                                                fontWeight: 'bold',
                                                textTransform: 'uppercase',
                                                letterSpacing: 1.5,
                                            }}>
                                            {t('modules_store.new')}
                                        </sup>
                                    </span>
                                }
                                leftIcon={<StoreIcon color={blue700} />}
                                onClick={() => push('/administration/store')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={14}
                                value={14}
                                primaryText={t('administration.statistics_tool')}
                                leftIcon={<IntegrationIcon color={blue700} />}
                                onClick={() => push('/administration/integration')}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={15}
                                value={15}
                                primaryText={t('invoice.invoices')}
                                leftIcon={<InvoiceIcon color={blue700} />}
                                onClick={() => push('/administration/invoices')}
                            />
                        </SelectableList>
                    </div>
                    <div className="col-md-10">{children}</div>
                </div>
            );
    }

    changeFilter(changedFilterMapping) {
        this.props.push(`/administration/task-ratings?filter=${changedFilterMapping.filter}`);
    }
}

const mapStateToProps = state => {
    const ownAccount = getOwnAccount(state);
    return {
        ownAccount: ownAccount,
        busCompany: getOwnCompany(state),
    };
};

export default withTranslation()(composeModalActions(connect(mapStateToProps, { push })(Administration)));
